@for (step of steps; track step; let index = $index; let isLast = $last) {
    <app-timeline-step [active]="isStepSelectedByIndex(index)"
                       [done]="isStepDoneByIndex(index)"
                       [isLastStep]="isLast">

        @if (step.label) {
            <app-timeline-label [innerHTML]="step.label" [id]="_getStepLabelId(index)" />
        } @else {
            <app-timeline-label [id]="_getStepLabelId(index)">
                @if (step.stepLabel?.template; as stepLabelTemplate) {
                    <ng-container [ngTemplateOutlet]="stepLabelTemplate" />
                }
            </app-timeline-label>
        }

        @if (isStepSelectedByIndex(index)) {
            <ng-container [ngTemplateOutlet]="step.content" />
        }
    </app-timeline-step>
}
